// CategoryScreen.js
import React, { useState, useEffect, useContext } from "react";
import useSWR from "swr";
import { API_BASE_URL } from "../Config";
import { useParams } from "react-router-dom";
import { Alert, Row, Col, Spinner, Container } from "react-bootstrap";
import { useTranslation } from 'react-i18next';

import { CartContext } from "../contexts/CartContext";
import { MaintenanceModeContext } from "../contexts/MaintenanceModeContext";
import { SvgErrorAlert } from "../components/Svgs";
import Product from "../components/Product";

import Banner from "../components/Banner"; 

function CategoryScreen() {
  const { t } = useTranslation();

  const categoryTranslations = {
    "Cabelos": t('hair'),
    "Cuidados Com a Pele": t('skin_care'),
    "Cuidados Faciais": t('facial_care'),
    "Óleos Perfumados": t('fragrant_oils'),
    "Perfumaria": t('perfumery'),
    "Sabonete": t('soaps'),
    "Cuidados com a barba": t('beard'),
    "Infantil": t('children'),
    "Maquiagem": t('makeup'),
    "Gifts": t('gifts'),

    // Novos itens (grupo Food)
    "Bebidas": t('drinks'),
    "Biscoitos e Snacks": t('snacks'),
    "Cereais e Misturas": t('cereals'),
    "Doces e Guloseimas": t('sweets'),
    "Grãos e Farináceos": t('grains'),
    "Óleos e Azeites": t('oils'),
    "Temperos e Condimentos": t('spices'),
    "Utensílios": t('utensils'),
  };
 
  const { categoryName } = useParams();

  const fetcher = (url) => fetch(url).then((res) => res.json());
  const { data, error } = useSWR(
    `${API_BASE_URL}/api/category/${categoryName}`,
    fetcher
  );

  const [isLoading, setIsLoading] = useState(false);
  const maintenanceMode = useContext(MaintenanceModeContext);

  const { products, setProducts } = useContext(CartContext);

  useEffect(() => {
    setIsLoading(!error && !data);
    if (data) {
      setProducts(data.products);
    }
  }, [data, setProducts, error]);


  if (maintenanceMode) {
    return <div className="text-center pt-5">{t('website_maintenance')}</div>;
  } else if (isLoading || !products) {
    return (
      <div className="spinning">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">{t('loading')}</span>
        </Spinner>
      </div>
    );
  } else {
    return (
      <Container>

        <Banner />
        
        {products.length > 0 && (
          <h3>{categoryTranslations[products[0].category_product]}</h3>
        )}

        {error && (
          <Alert variant="danger">
            <SvgErrorAlert /> {t('fetch_error')}
          </Alert>
        )}
        {products && (
          <>
            {products && data && data.products && (
              <Row>
                <Col>
                  <div className="text-center pb-3">
                    {data.products.length < 2 ? (
                      t('product_found', { count: data.products.length })
                    ) : (
                      t('products_found', { count: data.products.length })
                    )}
                  </div>
                </Col>
              </Row>
            )}

            <Row>
              {products.map((product) => (
                <Col
                  className="my-2 card-border"
                  sm={6}
                  md={6}
                  lg={4}
                  xl={3}
                  key={product.id}
                >
                  <Product key={product.id} product={product} sourceScreen="CategoryScreen" />
                </Col>
              ))}
            </Row>
          </>
        )}
      </Container>
    );
  }
}

export default CategoryScreen;
